/**
 * Recommended file sizes for uploaded pictures, as suggested by backend team.
 * 3MB per picture individually,
 * 20MB in total when selecting multiple pictures.
 */

export const megaByteInKb = 1048576
export const maxAllowedSizePerFileInKb = 3 * megaByteInKb // 3MB
export const maxAllowedTotalSizeInKb = 20 * megaByteInKb // 20MB
